import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, BrutalCard, EmptyState } from "../components/brutal";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";

export default function NotificationsPage() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  const load = () => api.get("/notifications").then((r) => setItems(r.data));

  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.patch(`/notifications/${id}/read`);
    load();
  };

  const readAll = async () => {
    await api.post("/notifications/read-all");
    load();
  };

  return (
    <div>
      <PageHeader
        title="Notifications"
        subtitle="Stage updates, points awarded, badge unlocks."
        right={
          <button className="btn-brutal btn-white" onClick={readAll} data-testid="read-all">
            <Check className="w-4 h-4" /> Mark all read
          </button>
        }
      />
      {items.length === 0 ? (
        <EmptyState title="You're all caught up" description="No notifications right now." />
      ) : (
        <div className="space-y-3">
          {items.map((n) => (
            <BrutalCard
              key={n.id}
              className={`p-5 flex items-start gap-4 cursor-pointer ${n.read ? "opacity-70" : ""}`}
              onClick={() => {
                if (!n.read) markRead(n.id);
                if (n.link) nav(n.link);
              }}
              data-testid={`notification-${n.id}`}
            >
              <div className={`w-3 h-3 mt-2 rounded-full ${n.read ? "bg-neutral-300" : "bg-brand-orange"}`} />
              <div className="flex-1 min-w-0">
                <div className="font-display font-black text-lg">{n.title}</div>
                <div className="text-sm text-neutral-700">{n.body}</div>
                <div className="text-[11px] uppercase tracking-widest text-neutral-500 mt-2">
                  {new Date(n.created_at).toLocaleString()}
                </div>
              </div>
            </BrutalCard>
          ))}
        </div>
      )}
    </div>
  );
}
